export default {
  homePageLink: '/',
  categoryPageLink: '/category',
  assetCartPageLink: '/assetcart',
  latestPageLink: '/latest',
};
